export function humbergerMenuButton(buttonEl, buttonInnerEl, menuEl) {
  if ($(buttonEl).length) {
    $(buttonEl).on("click", function () {
      console.log("hogeges");
      $(buttonInnerEl).toggleClass("active");
        // $(buttonEl).toggleClass("active");
      $(menuEl).slideToggle();
    });
  }
}
